import React from 'react';

import { useTranslation } from 'react-i18next';

import { config } from '@/config.ts';

import * as Styled from './quest-filter.styled';

export type QuestCategoryOption = {
	label: string;
	value: string | null;
};

type OwnProps = {
	isLoading: boolean;
	selected: QuestCategoryOption;
	categories: QuestCategoryOption[];
	setCategory: (filter: QuestCategoryOption) => void;
};

const isPmBrand = config.BRAND === 'pm';

export const QuestCategoryFilter = ({ categories, selected, setCategory, isLoading }: OwnProps) => {
	const { t } = useTranslation('main');
	if (categories.length === 0) {
		return null;
	}

	const isSelected = (filter: QuestCategoryOption): boolean => {
		return selected.value === filter.value;
	};
	return (
		<Styled.CategoriesWrapper>
			{categories.map(category => (
				<Styled.CategoryChip
					key={category.value || category.label}
					onClick={() => setCategory(category)}
					$round={!isPmBrand}
					$disabled={isLoading}
					$selected={isSelected(category)}
				>
					<Styled.CategoryName>{t(category.label)}</Styled.CategoryName>
				</Styled.CategoryChip>
			))}
		</Styled.CategoriesWrapper>
	);
};
